module.exports = __webpack_public_path__ + "img/afiliate-img.4b093f23.svg";